export default __webpack_public_path__ + "static/media/wwr-img.f411e298.webp";